// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"styles_menu-item__e3ccm","menu-item__inner":"styles_menu-item__inner__aCC9n","menu-item__label":"styles_menu-item__label__9O0Q1","disabled":"styles_disabled__3_cvA"};